import * as React from 'react'

import { Box, Button, Link } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Callout from 'modules/core/components/Callout'
import PanesHeader from 'modules/core/components/PanesHeader'
import i18n from 'modules/core/lib/i18n'

import { ApprovalsConfigurationBlockProps } from 'modules/approvals/components/ApprovalsConfigurationBlock/ApprovalsConfigurationBlockProps'

import NewGroupModal from './NewGroupModal'

export interface ApprovalGroupDescriptionProps extends ApprovalsConfigurationBlockProps {
  canCreateGroup: boolean
}

const ApprovalGroupDescription = ({
  category,
  title,
  description,
  multigroup,
  hideAddGroupButton,
  helpCenterUrlName,
  icon,
  onAddGroup,
  addGroupButtonFallback,
  canCreateGroup,
}: ApprovalGroupDescriptionProps) => {
  const [showModal, setShowModal] = React.useState(false)
  const [showHelpTip, setShowHelpTip] = React.useState(true)

  return (
    <Box>
      <PanesHeader illustration={icon} title={title} description={description} />
      {!hideAddGroupButton && (
        <Box gap="s24">
          {canCreateGroup && multigroup && (
            <Box width="fit-content">
              <Button
                type="secondary"
                onClick={onAddGroup || (() => setShowModal(true))}
                iconName="add"
              >
                {i18n.t('settings.approvals.add_button')}
              </Button>
            </Box>
          )}
          {showHelpTip && helpCenterUrlName && (
            <Box style={{ maxWidth: '500px' }}>
              <Callout
                type="info"
                title={i18n.t('settings.approvals.need_help')}
                description={i18n.t('settings.approvals.extra_info')}
                link={
                  <Link.Href href={helpCenterUrlName} target="_blank" type="solid">
                    {i18n.t('settings.approvals.learn_more')}
                  </Link.Href>
                }
                onRemove={() => setShowHelpTip(false)}
              />
            </Box>
          )}
        </Box>
      )}
      {hideAddGroupButton && addGroupButtonFallback}
      {showModal && (
        <NewGroupModal
          onClose={() => setShowModal(false)}
          category={category}
          illustration={icon}
        />
      )}
    </Box>
  )
}

export default observer(ApprovalGroupDescription)
